import SpinnerAnimatedIcon from './component.jsx'
export default SpinnerAnimatedIcon
